import { ref } from 'vue';
import { showToast, showLoadingToast, showSuccessToast, showFailToast } from 'vant';
// import { options } from '../../api/utils/address.ts';
import { get, post } from '../../api/utils/request.ts';
import MyNavBarVue from '../../components/MyNavBar.vue';
import moment from 'moment';
export default {
  components: {
    MyNavBarVue
    //  detail 
  },

  setup() {
    const options = ref([]);
    const fieldValue = ref('');
    const Linkman = ref('');
    const ContactNumber = ref('');
    const Remark = ref('');
    const Address = ref('');
    const showCounty = ref(false);
    const CountyValue = ref('');
    const imgvalue = ref();
    const ExpectedServiceTime = ref('');
    const ShowDate = ref(false);
    const SN = ref('');
    const Model = ref('');
    const showSN = ref(false);
    const County = ref('');
    const Town = ref('');
    const Road = ref('');
    const SNNames = {
      text: 'text',
      value: 'text'
    };
    const Toast = showtext => {
      showToast({
        message: showtext,
        position: 'bottom'
      });
    };
    //日期
    const DateList = ref([]);
    const minDate = ref();
    // 地址选择
    const onFinish = selectedOptions => {
      showCounty.value = false;
      var so = selectedOptions.selectedOptions;
      fieldValue.value = so[0].text + "" + so[1].text + "" + so[2].text;
      County.value = so[0].text;
      Town.value = so[1].text;
      Road.value = so[2].text;
    };
    //日期格式化
    const formatDate = date => `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;
    //日期选择
    const onConfirmDate = value => {
      ShowDate.value = false;
      ExpectedServiceTime.value = formatDate(value);
    };
    //设备列表
    const SNList = [];
    //选择设备方法
    const onConfirmSN = ({
      selectedValues
    }) => {
      showSN.value = false;
      // SN.value = selectedValues.join(',');
      console.info(selectedValues);
      var str = selectedValues.join(',').split("|");
      SN.value = str[1].trim();
      Model.value = str[0].trim();
    };
    const onSubmit = values => {};
    const fileList = [];
    const objIsEmpty = obj => {
      if (typeof obj === 'undefined' || obj == null || obj === '') {
        return true;
      } else {
        return false;
      }
    };
    const formatter = day => {
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      console.info(DateList.value);
      console.info(moment(day.date).format('yyyy/MM/DD'));
      var p = DateList.value.find(x => x.ca_Date == moment(day.date).format('yyyy/MM/DD'));
      if (p) {
        if (p.workingDay == "N") {
          day.type = 'disabled';
        }
      }
      return day;
    };
    return {
      formatter,
      Model,
      fieldValue,
      Toast,
      objIsEmpty,
      fileList,
      County,
      Town,
      Road,
      Linkman,
      ContactNumber,
      Remark,
      Address,
      SN,
      SNNames,
      SNList,
      DateList,
      showSN,
      ExpectedServiceTime,
      ShowDate,
      showCounty,
      CountyValue,
      options,
      imgvalue,
      onFinish,
      onConfirmDate,
      onConfirmSN,
      onSubmit,
      minDate
    };
  },
  data() {
    return {
      CustomerName: "",
      CustomerCode: "",
      query: {}
    };
  },
  created() {//在组件实例处理完所有与状态相关的选项后调用。
  },
  mounted() {
    //在组件被挂载之后调用

    this.query = this.$route.query;
    this.CustomerName = this.query.CustomerName;
    this.CustomerCode = this.query.CustomerCode;
    this.ContactNumber = this.query.CellPhone;
    this.Linkman = this.query.Name;
    this.getAreaList();
    //获取设备
    get('/api/services/app/ServiceRecord/GetEquipmentListByCNo', {
      CNo: this.CustomerCode
    }).then(res => {
      if (res.success) {
        this.SNList = res.result;
      }
    });
    //获取日期
    get('/api/services/app/ServiceRecord/GetDateTimeList').then(res => {
      if (res.success) {
        this.DateList = res.result;
        var z = 3;
        var flag = true;
        do {
          var p = this.DateList.find(x => x.ca_Date == moment(new Date(new Date().getTime() + z * 24 * 60 * 60 * 1000)).format('yyyy/MM/DD').toString());
          if (p) {
            if (p.workingDay == "N") {
              flag = true;
              z++;
            } else {
              flag = false;
            }
          } else {
            flag = false;
          }
        } while (flag);
        this.minDate = new Date(new Date().getTime() + z * 24 * 60 * 60 * 1000);
      }
    });
  },
  methods: {
    // 从接口请求获取第一层的数据，---比如北京
    async getAreaList() {
      get('/api/services/app/ServiceRecord/GetTWAddressList', {
        type: 1,
        parentId: ''
      }).then(res => {
        if (res.success) {
          this.options = res.result;
        }
      });
    },
    onChange({
      value,
      selectedOptions,
      tabIndex
    }) {
      // showLoadingToast({
      //   message: '',
      //   forbidClick: true,
      //   duration:0
      // });
      // 需要后台接口返回children数据
      // 拿到数据后，动态添加
      get('/api/services/app/ServiceRecord/GetTWAddressList', {
        type: 2,
        parentId: value
      }).then(res => {
        if (res.success) {
          // closeToast()
          this.options.forEach(item => {
            if (item.value === value) {
              item.children = res.result;
            }
            item.children.forEach(item_c => {
              if (item_c.value === value) {
                console.info(item_c.value);
                item_c.children = res.result;
                item_c.children.forEach(item_cc => {
                  item_cc.children = null;
                });
              }
            });
          });

          // this.addTree(selectedOptions, res.result, value)
          // this.options= res.result
        }
      });
    },

    checkend() {
      //验证
      if (this.objIsEmpty(this.query.CustomerCode)) {
        this.Toast('未獲取到客戶代碼');
        return;
      }
      if (this.objIsEmpty(this.Linkman)) {
        this.Toast('請輸入聯繫人');
        return;
      }
      if (this.objIsEmpty(this.ContactNumber)) {
        this.Toast('請輸入聯繫方式');
        return;
      }
      if (this.objIsEmpty(this.SN)) {
        this.Toast('請選擇保養設備');
        return;
      }
      if (this.objIsEmpty(this.ExpectedServiceTime)) {
        this.Toast('請選擇預約時間');
        return;
      }
      if (this.objIsEmpty(this.CountyValue)) {
        this.Toast('請選擇所在地區');
        return;
      }
      if (this.objIsEmpty(this.Address)) {
        this.Toast('請輸入詳細地址');
        return;
      }
      showLoadingToast({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      });
      let formData = new FormData();
      formData.append('customerCode', this.query.CustomerCode);
      formData.append('customerName', this.query.CustomerName);
      formData.append('serviceType', 2);
      formData.append('linkman', this.Linkman);
      formData.append('contactNumber', this.ContactNumber);
      formData.append('sN', this.SN);
      formData.append('expectedServiceTime_str', this.ExpectedServiceTime);
      formData.append('county', this.County);
      formData.append('town', this.Town);
      formData.append('road', this.Road);
      formData.append('address', this.Address);
      // formData.append('IsShutdown',this.IsShutdown==1?true:false)
      formData.append('remark', this.Remark);
      formData.append('store', this.query.Store);
      formData.append('business', this.query.Business);
      // formData.append('hours',0)
      //提交报修
      post('/api/services/app/ServiceRecord/Create', formData).then(res => {
        if (res.success) {
          if (res.result.code == 200) {
            showSuccessToast('提交成功');
            console.info(res);
            setTimeout(() => {
              this.$router.go(-1);
            }, 500);
          } else {
            showFailToast(res.result.msg);
          }
        } else {
          showFailToast('提交失敗');
        }
      });
    }
  }
};